
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diet",
      function () {
        return require("private-next-pages/diet/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diet"])
      });
    }
  